import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoHallazgosPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoHallazgos {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoHallazgosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoHallazgosService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_hallazgos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los tipos de hallazgo
   */
  getAll(): Observable<TipoHallazgos[]> {
    return this.http.get<TipoHallazgos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener tipo de hallazgo por ID
   */
  getById(id: number): Observable<TipoHallazgos> {
    return this.http.get<TipoHallazgos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear tipo de hallazgo
   */
  create(
    payload: TipoHallazgosPayload
  ): Observable<TipoHallazgosResponse> {
    return this.http.post<TipoHallazgosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar tipo de hallazgo
   */
  update(
    id: number,
    payload: Partial<TipoHallazgosPayload>
  ): Observable<TipoHallazgosResponse> {
    return this.http.put<TipoHallazgosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar tipo de hallazgo
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar tipo de hallazgo
   */
  inactivar(id: number): Observable<TipoHallazgosResponse> {
    return this.http.put<TipoHallazgosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar tipo de hallazgo
   */
  activar(id: number): Observable<TipoHallazgosResponse> {
    return this.http.put<TipoHallazgosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}